import * as React from 'react'
import styled from 'styled-components/macro'
import Featured1 from 'assets/images/HomeImages/Featured1.png'
import SweetSpotLogo from 'assets/images/HomeImages/sweetspot.jpg'
import Featured3 from 'assets/images/HomeImages/Featured3.png'
import Launcher from 'assets/images/HomeImages/Launcher.jpg'
import {Link} from 'react-router-dom'
import {QUERIES} from 'common/constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* Background Gradient */

  background: linear-gradient(
    180deg,
    rgba(52, 52, 52, 0.85) 8.87%,
    rgba(26, 26, 26, 0.85) 100%
  );
  width: 100%;
  padding: 64px 16px 40px 16px;
  @media ${QUERIES.tabletAndUp} {
    padding-top: 96px;
    padding-bottom: 144px;
    padding: 96px 128px 144px 128px;
  }
`

const Title = styled.div`
  color: white;
  font-family: 'Rubik';
  font-weight: bold;
  font-size: calc(24 / 16 * 1rem);
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(40 / 16 * 1rem);
  }
  line-height: 47px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  margin-bottom: 32px;
`

const Boxes = styled.div`
  display: flex;
  flex-direction: column;
  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    overflow-x: scroll;
  }
  gap: 16px;
`

const ServiceBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #343434;
  @media ${QUERIES.tabletAndUp} {
    max-width: 384px;
    min-width: 33%;
    *:not(a) {
      filter: saturate(0);
    }

    :hover {
      *:not(a) {
        filter: saturate(100%);
      }

      a {
        background-color: var(--light-green);
        border: 3px solid var(--light-green);
      }
    }
  }
`

const ServiceImageContainer = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 1s ease;
  img {
    width: 100%;
    max-height: 315px;
  }
`

const ServiceImage = styled.img``

const BottomSection = styled.div`
  color: white;
  font-family: 'Rubik';
  padding: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${QUERIES.tabletAndUp} {
    align-items: flex-start;
  }
`

const SubTitle = styled.div`
  font-size: calc(20 / 16 * 1rem);
  @media ${QUERIES.tabletAndUp} {
    font-size: calc(24 / 16 * 1rem);
  }
  font-style: italic;
  text-transform: uppercase;
`

const Message = styled.div`
  color: white;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  line-height: 20px;
  -webkit-box-orient: vertical;
  @media ${QUERIES.tabletAndUp} {
    text-align: inherit;
  }
  font-family: 'Mulish';
  font-weight: 300;
`

const LearnMoreButton = styled(Link)`
  transition: all 1s ease;
  background-color: var(--darker-grey);
  color: var(--white);
  border-radius: 5px;
  font-family: 'Rubik';
  font-weight: 700;
  font-size: calc(12 / 16 * 1rem);
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  margin-top: 16px;
  padding: 12px 24px;
  border: 3px solid var(--darker-grey);
  width: fit-content;
  white-space: nowrap;
  text-decoration: none;
`

const FeaturedServices = () => {
  return (
    <Container>
      <Title>Featured Services</Title>
      <Boxes>
        <ServiceBox>
          <ServiceImageContainer>
            <ServiceImage src={Featured1} alt="Hole-in-one packages" />
          </ServiceImageContainer>
          <BottomSection>
            <SubTitle>Hole-in-one packages</SubTitle>
            <Message>
              Choose one of our various Hole-in-One prize packages to enhance a
              golf outing experience,...
            </Message>
            <LearnMoreButton to="/holeinone">Learn More</LearnMoreButton>
          </BottomSection>
        </ServiceBox>
        <ServiceBox>
          <ServiceImageContainer>
            <ServiceImage src={SweetSpotLogo} alt="Sweet Spot Software" />
          </ServiceImageContainer>
          <BottomSection>
            <SubTitle>Sweet Spot Software</SubTitle>
            <Message>
              Golf event planning is made easy for everyone with Sweet Spot
              Software. Created to ease the stress of...
            </Message>
            <LearnMoreButton to="/sweetspot">Learn More</LearnMoreButton>
          </BottomSection>
        </ServiceBox>
        <ServiceBox>
          <ServiceImageContainer>
            <ServiceImage src={Featured3} alt="Apparel" />
          </ServiceImageContainer>
          <BottomSection>
            <SubTitle>Apparel</SubTitle>
            <Message>
              Explore our entire apparel selection to find the perfect item for
              you and your team. Inquire for further details on...
            </Message>
            <LearnMoreButton to="/gifts/apparel">Learn More</LearnMoreButton>
          </BottomSection>
        </ServiceBox>
        <ServiceBox>
          <ServiceImageContainer>
            <ServiceImage src={Launcher} alt="Launcher" />
          </ServiceImageContainer>
          <BottomSection>
            <SubTitle>Golf Ball Launcher</SubTitle>
            <Message>
              Players can launch a golf ball upwards of 450 yards utilizing our
              state-of-the-art, no-kick golf ball launchers.
            </Message>
            <LearnMoreButton to="/launcher">Learn More</LearnMoreButton>
          </BottomSection>
        </ServiceBox>
      </Boxes>
    </Container>
  )
}
export default FeaturedServices
